import React from 'react';
import styles from './Sidebar.css';

function SidebarItem(props) {
  const { iconClass, label, active, sidebarItemClicked } = props;
  return (
    <div>
      <div
        style={{ backgroundColor: active ? 'var(--secondaryColor)' : '' }}
        className={styles.sidebarItem + ' mag-sidebar-item'}
        onClick={() => sidebarItemClicked(props)}
      >
        <div>
          <i className={iconClass}></i>
          <span className='liLabel'>{label}</span>
        </div>
      </div>
      <span
        className={styles.arrowLeft}
        style={{ display: active ? 'inline-block' : 'none' }}
      ></span>
    </div>
  );
}

export default SidebarItem;
